import React from 'react';
import Head from 'next/head'
import { get } from "lodash";
import { ContentfulApi } from "../../../api/ContentfulApi";
import TermsTemplate from "../../../components/Terms/TermsTemplate/TermsTemplate";
import { getServerSideLocaleData } from "../../../utils/server-side/getLocaleData";
import Breadcrumb from "../../../components/Breadcrumb";

const ReferralTerms = ({ guestTerms, hostTerms, redirectUrl }) => {
    const showBreadcrumb = !!guestTerms || !!hostTerms;
    const showGuestTerms = !!guestTerms;
    const showHostTerms = !!hostTerms;
    return (
        <div>
            <Head>
                <title>Peerspace</title>
                <link rel="icon" href="https://assets.peerspace.com/peerspace_favicon-196x196.png?v=rb" />
            </Head>
            <div className="container pt-10">
                {showBreadcrumb && <Breadcrumb breadCrumbLinks={guestTerms.breadCrumbLinks} redirectUrl={redirectUrl} />}
                {showGuestTerms &&
                    <div className="row">
                        <div className="col-12">
                            <TermsTemplate {...guestTerms} />
                        </div>
                    </div>
                }
                {showHostTerms &&
                    <div className="row">
                        <div className="col-12">
                            <TermsTemplate {...hostTerms} />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export const getServerSideProps = async (context) => {
    const localeProps = await getServerSideLocaleData(context);
    const locale = get(localeProps ,'locale', 'en-US');
    const guestData = await ContentfulApi.getGuestReferralTerms(locale);
    const hostData = await ContentfulApi.getHostReferralTerms(locale);
    return {
        props: {
            ...localeProps,
            redirectUrl: 'legal/terms/referral-terms',
            guestTerms: guestData,
            hostTerms: hostData,
        }
    }
}

export default ReferralTerms;
